export default {
  namespaced: true,
  comandos_alarmes: {
    title: "Comandos de alarmes",
    add_alarm_command: 'Adicionar comando de alarme',
    edit_alarm_command: 'Editar comando de alarme',
  },
};
